import { Component, OnInit } from '@angular/core';
import { ChartType } from 'chart.js';
import { WebServicesService } from 'src/app/container/internal/internal-home/pages/webservices/webservices.service';
import { HomeExternalService } from 'src/app/container/external/shared/home/home-external.service';
import { VistaRapida } from 'src/app/core/entities/vistarapida.models';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-donas4',
  templateUrl: './donas.component.html',
  styleUrls: ['./donas.component.scss']
})
export class Donas4Component implements OnInit {

  vistaRapidaActivo: VistaRapida = new VistaRapida();

  public doughnutChartType: ChartType = 'doughnut';

  public doughnutChartData: any = {
    labels: [],
    datasets: [
      {
        data: [0, 0],
        backgroundColor: ['#28a745', '#dc3545']
      }
    ]
  };

  public chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
  }

  constructor(private translateService: TranslateService,
              private webServicesService : WebServicesService,
              private homeExternalService: HomeExternalService) { }

  ngOnInit(): void {
    if(this.webServicesService.vistaRapidaObj.active){
      this.vistaRapidaActivo =  _.cloneDeep(this.webServicesService.vistaRapidaObj);
      this.actualizarGrafico();
    }

    if(this.homeExternalService.vistaRapidaObj.active){
      this.vistaRapidaActivo =  _.cloneDeep(this.homeExternalService.vistaRapidaObj);
      this.actualizarGrafico();
    }
  }

  actualizarGrafico(): void {
    this.doughnutChartData.datasets[0].data = [
      +this.vistaRapidaActivo.contImporNotFac.toFixed(2),
      +this.vistaRapidaActivo.contImporFac.toFixed(2)
    ];

    this.doughnutChartData.labels = [
      this.translateService.instant('WEBSERVICES.VISTA_RAPIDA.CONTRATOS.nofacturado'),
      this.translateService.instant('WEBSERVICES.VISTA_RAPIDA.CONTRATOS.facturado')
    ];
  }

  //event
  public chartClicked({ event, active }: { event: MouseEvent, active: {}[] }): void {
    //console.log(event, active);
  }

  //event
  public chartHovered({ event, active }: { event: MouseEvent, active: {}[] }): void {
    //console.log(event, active);
  }

}